var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayCheckboxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.90668C0 1.82027 1.69137 0.128906 3.77778 0.128906H13.2222C15.3086 0.128906 17 1.82028 17 3.90668V13.3511C17 15.4375 15.3086 17.1289 13.2222 17.1289H3.77778C1.69137 17.1289 0 15.4375 0 13.3511V3.90668Z",
    fill: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0303 5.59858C13.3232 5.89147 13.3232 6.36634 13.0303 6.65924L7.53033 12.1592C7.23744 12.4521 6.76256 12.4521 6.46967 12.1592L3.96967 9.65924C3.67678 9.36634 3.67678 8.89147 3.96967 8.59858C4.26256 8.30568 4.73744 8.30568 5.03033 8.59858L7 10.5682L11.9697 5.59858C12.2626 5.30568 12.7374 5.30568 13.0303 5.59858Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheckboxIcon);
export default __webpack_public_path__ + "static/media/gray-checkbox-icon.cf23a2b0e6f188029d9d4a289f6b819f.svg";
export { ForwardRef as ReactComponent };